import {Connections, getConnection} from '@vio/core/src/auth/modules/selectors'
import {User} from '@vio/core/src/auth/types/Cognito'
import {CustomerAccountType} from '@vio/core/src/booking/types/BookingRequest'

export const mapUserAuthenticationMethod = (
  authenticationMethod: Connections | null
): CustomerAccountType['authenticationMethod'] => {
  const authenticationMethodMap: Record<
    string,
    CustomerAccountType['authenticationMethod']
  > = {
    'google-oauth2': 'google',
    facebook: 'facebook'
    // FIXME: add support to Apple in BoVio API in the future
    // apple: 'apple'
  }

  if (authenticationMethod && authenticationMethod in authenticationMethodMap)
    return authenticationMethodMap[authenticationMethod]

  // Fallback Google to avoid blocking bookings due to error in mapping in new authentication methods like Apple
  return authenticationMethodMap[Connections.Google]
}

export const getCustomerAccount = (
  user: User | null,
  isMemberPlus = false
): CustomerAccountType => {
  if (!user) {
    return {
      type: 'guest'
    }
  }

  const {attributes, updatedAt, createdAt} = user || {}
  const {email, email_verified, sub, given_name, family_name} = attributes || {}
  const authenticationMethod = getConnection(user)

  return {
    id: sub,
    lastLogin: updatedAt,
    type: 'registered',
    email,
    emailVerified: email_verified,
    updatedAt,
    authenticationMethod: mapUserAuthenticationMethod(authenticationMethod),
    createdAt,
    memberPlus: isMemberPlus,
    firstName: given_name,
    lastName: family_name
  }
}
